import {tns} from 'tiny-slider/src/tiny-slider';


function toggleTabs(options) {

    /* Example options
    {
        toggleButtonsWrapperClass:'className',
        $toggleButtonsWrapper:node,
        toggleButtonClass:'className',
        $toggleButtons:HTMLCollections,
        toggleButtonActiveClass:'className',

        toggleItemsWrapperClass:'className',
        $toggleItemsWrapper:node,
        toggleItemsClass:'className',
        $toggleItems:HTMLCollections,
        toggleItemActiveClass:'className',
        toggleItemActiveEffectClass: 'className'
    }
     */

    let toggleButtonsWrapperClass = options && options.toggleButtonsWrapperClass ? options.toggleButtonsWrapperClass : 'tabs__toggle-buttons';
    let $toggleButtonsWrapper = options && options.$toggleButtonsWrapper ? options.$toggleButtonsWrapper : document.getElementsByClassName(toggleButtonsWrapperClass)[0];
    let toggleButtonClass = options && options.toggleButtonClass ? options.toggleButtonClass : 'tabs__toggle-button';
    let toggleButtons = options && options.toggleButtons ? options.toggleButtons : $toggleButtonsWrapper.getElementsByClassName(toggleButtonClass);
    let toggleButtonActiveClass = options && options.toggleButtonActiveClass ? options.toggleButtonActiveClass : 'tabs__toggle-button--active';

    let toggleItemsWrapperClass = options && options.toggleItemsWrapperClass ? options.toggleItemsWrapperClass : 'tabs__toggle-items';
    let $toggleItemsWrapper = options && options.$toggleItemsWrapper ? options.$toggleItemsWrapper : document.getElementsByClassName(toggleItemsWrapperClass)[0];
    let toggleItemClass = options && options.toggleItemClass ? options.toggleItemClass : 'tabs__toggle-item';
    let toggleItems = options && options.toggleItems ? options.toggleItems : $toggleItemsWrapper.getElementsByClassName(toggleItemClass);
    let toggleItemActiveClass = options && options.toggleItemActiveClass ? options.toggleItemActiveClass : 'tabs__toggle-item--active';
    let toggleItemActiveEffectClass = options && options.toggleItemActiveEffectClass ? options.toggleItemActiveEffectClass : 'tabs__toggle-item--active-effect';

    init();

    this.showItem = (name) => {
        showItem(name);
    };

    function hideItems() {
        for (let i = 0; i < toggleItems.length; i++) {
            toggleItems[i].classList.remove(toggleItemActiveClass, toggleItemActiveEffectClass);
        }

        for (let $toggleButton of toggleButtons) {
            $toggleButton.classList.remove(toggleButtonActiveClass);
        }
    }

    function showItem(name, notEffect) {

        hideItems();

        for (let index = 0; index < toggleItems.length; index++) {
            if (toggleItems[index].dataset.tabsName === name) {
                toggleItems[index].classList.add(toggleItemActiveClass);

                if (notEffect) {
                    toggleItems[index].classList.add(toggleItemActiveEffectClass);
                } else {
                    let checkDisplay = setInterval(() => {
                        let computedStyle = window.getComputedStyle(toggleItems[index], null);
                        let displayState = computedStyle.getPropertyValue('display') !== 'none';

                        if (displayState) {
                            toggleItems[index].classList.add(toggleItemActiveEffectClass);
                            clearInterval(checkDisplay);
                        }
                    }, 1);
                }

                window.history.replaceState(`${name}`, 'Tabs state', `${window.location.origin}${window.location.pathname}?tabs=${name}`);
            }
        }

        for (let $button of toggleButtons) {
            if ($button.dataset.tabsNameTarget === name) {
                $button.classList.add(toggleButtonActiveClass);
            }
        }
    }

    $toggleButtonsWrapper.addEventListener('click', (e) => {
        const $target = e.target;

        let $clickButton = false;

        if ($target.classList.contains(toggleButtonClass)) {
            $clickButton = $target;
        } else if ($target.closest('.' + toggleButtonClass) !== null) {
            $clickButton = $target.closest('.' + toggleButtonClass);
        }

        if ($clickButton && !$clickButton.classList.contains(toggleButtonActiveClass)) {
            showItem($clickButton.dataset.tabsNameTarget);
        }
    });

    function init() {
        let names = [];

        for (let $toggleItem of toggleItems) {
            names.push($toggleItem.dataset.tabsName);
        }

        let getParams = new URLSearchParams(window.location.search).get('tabs');

        if (getParams !== null && names.indexOf(getParams) !== -1) {
            showItem(getParams, true);
        } else {
            showItem(names[0], true);
        }
    }


}

if (Array.from(document.getElementsByClassName('tabs')).length > 0) {
    window.tabs = new toggleTabs();

    let $slider = document.getElementsByClassName('tabs__toggle-buttons')[0];

    setTabsSlider($slider);
}

function setTabsSlider($slider) {
    let tabsItems = Array.from(document.getElementsByClassName('tabs__toggle-item'));
    let initIndex = 0;

    for (let index = 0; index < tabsItems.length; index++) {
        if (tabsItems[index].classList.contains('tabs__toggle-item--active')) {
            initIndex = index;
        }
    }

    let sliderNav = $slider.closest('.tabs').getElementsByClassName('tabs__toggle-nav')[0];

    let slider = tns({
        container: $slider,
        items: 1,
        slideBy: 1,
        nav: false,
        mouseDrag: true,
        loop: false,
        startIndex: initIndex,
        speed: 300,
        controls: true,
        controlsContainer: sliderNav,
        disable: false,
        responsive: {
            1280: {
                disable: true,
            },
        },
    });
// .goTo(3);
    let customizedFunction = function (info) {
        window.tabs.showItem(document.getElementsByClassName('tabs__toggle-button')[info.displayIndex - 1].dataset.tabsNameTarget);
    };

    slider.events.on('indexChanged', customizedFunction);
}
